/**
 * 充值下单模块
 * @author zhenn
 * @time 2016-11-17
 */
import React, { Component } from "react";
import channelConfig from "../global/channel-config";
import url from "c-url";
import loading from "c-loading";
import Pbajax from "up-pbajax";
import orderpb from "./orderpb";
import publicpb from "../global/publicpb";
import Notification from "../global/notification";
import lang from "../lang/index";
import Poppay from "../popup/bank-pay-popup";
import InvoiceDialog from "../popup/dialog-invoice";
import global from "../global/global";
import Native from "c-up-native";

export default (ComposedComponent) => {
    class Order extends Component {
        constructor(props) {
            super(props);
            this.state = {
                uid: props.uid,
            };
            this.pbajax = new Pbajax();
        }

        onSelectPay(pid, ext) {
            let data = {
                purpose: 1, // 钻石
                productId: Number(pid),
                channel: channelConfig.option,
                tradeType: "WAP",
                tuid: Number(this.state.uid),
                returnUrl: window.location.href,
            };
            // 为pc uplive做充值统计，页面参数上会携带from=pcuplive
            let froms = url.query("from");
            let clientType = url.query("clientType");

            if (froms == "pcuplive") {
                data.clientType = "pcuplive";
            }

            if (clientType) {
                data.clientType = clientType;
            }

            if (ext) {
                data.ext = JSON.stringify(ext);
            }

            this.doSubmit(data);
        }

        backSelect() {
            this.onSelectPay();
        }

    async  doSubmit(data) {
            const reCaptchaToken = await global.execute('payOrder');
            const res = (await window.inspect('payOrder')) || {};
            payload = res.payload;
            data.riskCheckParam = {
                reCaptchaToken,
            };
            loading.show({
                text: "loading",
            });
            let userAgent;
            let system = Native.getSystem();
            if (Native.getPlatform() == "uplive") {
                let ua = navigator.userAgent;
                let reg = /uplive\/(.*?)\s/i;
                let versionArr = reg.exec(ua);
                if (versionArr && versionArr[0]) {
                    let version = versionArr[1];
                    if (system == "android") {
                        userAgent = `Android/google version/${version} `;
                    } else {
                        userAgent = `iOS/appstore version/${version} `;
                    }
                } else {
                    userAgent = `H5/h5 version/9.9.9 `;
                }
            } else {
                userAgent = `H5/h5ipay version/9.9.9 `;
            }

            this.pbajax.do(
                {
                    service: "mall-recharge",
                    api: "/recharge/pay/order",
                    header: {
                        UserAgent: userAgent,
                        payload
                    },
                    inchina: 1,
                },

                new orderpb.Mall.PayOrder.Request(data),

                (res) => {
                    loading.hide();
                    let dataWrap = publicpb.Result.decode(res);

                    if (dataWrap.code == 1) {
                        let data = orderpb.Mall.PayOrder.Response.decode(
                            dataWrap.data.value
                        );

                        if (channelConfig.option == "sinopac_atm") {
                            //台湾银行汇款 弹框
                            this.handleBankPay(data);
                        } else if (channelConfig.option == "bk_atm") {
                            let payUrl = data.h5;
                            payUrl = payUrl.replace("zh-CN", "vi-VN");
                            payUrl += "&web=3";
                            location.replace(payUrl);
                        } else if (
                            [
                                "pepay_entitycard_thb",
                                "pepay_entitycard_idr",
                                "pepay_onlinebank_idr",
                                "pepay_alfamart_idr",
                                "pepay_onlinebank_vnd",
                                "pepay_entitycard_vnd",
                                "paytm",
                                "pepay_webatm_idr",
                                "gash",
                                "gash_card",
                            ].indexOf(channelConfig.option) !== -1
                        ) {
                            loading.show({
                                text: "loading",
                            });

                            let backAddr = data.h5;
                            let [actions, attrs] = backAddr.split("?");

                            if (attrs) {
                                let arr = attrs.split("&");
                                // let inputs = [];

                                arr = arr.map((item, i) => {
                                    // let [key, v] = item.split('=');

                                    // 由于此处参数的值有可能是md5加密串，有一定概率会出现多个等于号，后端没有转义,
                                    // 这会扰乱正常的参数取值，java无法修改历史渠道，要求前端处理
                                    // 此处改成切割第一个等于号的方式获取key和value
                                    const firstEqIdx = item.indexOf("=");
                                    const key = item.substr(0, firstEqIdx);
                                    const v = item.substr(firstEqIdx + 1);
                                    return (
                                        '<input type="hidden" name="' +
                                        key +
                                        '" value="' +
                                        v +
                                        '" />'
                                    );
                                });

                                let forms = [
                                    '<form method="post" action="' +
                                        actions +
                                        '">',
                                    ...arr,
                                    "</form>",
                                ];
                                let $form = $(forms.join(""));
                                $(document.body).append($form);

                                $form[0].submit();
                            }
                        } else {
                            loading.show({
                                text: "loading",
                            });

                            location.replace(data.h5);
                        }
                        //location.replace(data);
                    } else {
                        let tip;

                        switch (parseInt(dataWrap.code, 10)) {
                            case 12293:
                                tip = lang.template("金额或次数限充");
                                break;
                            case 4096:
                                tip = lang.template("参数错误");
                                break;
                            default:
                                tip = lang.template("系统错误");
                                break;
                        }
                        new Notification({
                            content: tip,
                        }).create();
                    }
                },

                () => {
                    loading.hide();
                    new Notification({
                        content: lang.template("网络连接有误, 请稍后再试"),
                    }).create();
                }
            );
        }

        handleBankPay(data) {
            let itemData = global.selectedOption;

            let orderData = {
                orderId: data.orderInfo.orderId,
                //accountId:data.h5,
                amount: itemData.amount, //充值额度
                money: itemData.money / 100,
                moneySymbol: itemData.currencySymbol,
            };
            Poppay.create({ orderData: orderData });
        }
        componentWillUnmount() {
            this.pbajax.cancel();
        }

        render() {
            return (
                <ComposedComponent
                    uid={this.state.uid}
                    onSelectPay={this.onSelectPay.bind(this)}
                />
            );
        }
    }

    return Order;
};



// WEBPACK FOOTER //
// ./js/order/index.js